// extracted by mini-css-extract-plugin
export default {"record-writebox":"BodyMassWrite_record-writebox__nMDij","date-record":"BodyMassWrite_date-record__-kfh4","time-record":"BodyMassWrite_time-record__syLlk"};